<template>
  <v-dialog v-model="sharingDialog" width="500" persistent>
    <v-card flat>
      <v-layout justify-center>
        <v-flex xs12>
          <v-card flat color="grey lighten-2 pa-3">
            <v-toolbar>
              <v-spacer></v-spacer>
              <span class="title text-uppercase font-weight-bold">Sharing</span>
              <v-spacer></v-spacer>
              <v-btn color="error" icon large @click="closeDialog">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-layout wrap>
              <v-flex xs12>
                <v-btn @click="test()">aaa</v-btn>
                <v-card>
                  <p>{{item.articleId}}</p>
                  <!-- <div
                    class="fb-share-button"
                    :data-href="currentURL"
                    data-layout="button"
                    data-size="large"
                  ></div> -->
                  <div
                    class="fb-share-button"
                    :data-href="currentURL"
                    data-layout="button_count"
                    data-size="large"
                  ></div>
                  <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-btn text icon v-on="on" @click="getUrlDown">
                        <v-icon medium>fas fa-share-alt</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <textarea
                          auto-grow
                          :no-resize="true"
                          row-height="30"
                          readonly
                          rows="2"
                          outlined
                          ref="gettingTheUrl"
                          v-model="currentURL"
                          cols="40"
                        ></textarea>
                        <v-btn @click="copyThisUrl">{{
                          $t("Copy Url To Clipboard")
                        }}</v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <div 
                    class="fb-share-button" 
                    :data-href="currentURL"
                    data-layout="button_count" 
                    data-size="small"
                  >
                    <a target="_blank" :data-href="currentURL" class="fb-xfbml-parse-ignore">Share</a>
                  </div>

                  <div 
                    class="fb-share-button" 
                   :data-href="currentURL" 
                    data-layout="button" 
                    data-size="small"
                  >
                      <a target="_blank" :data-href="currentURL"
                      class="fb-xfbml-parse-ignore">Share</a>
                    </div> -->
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>


<script>
  export default {
    data(){
      return{
        sharingDialog : false,
        item: {},
        currentURL: window.location.href,
      }
    },
    methods: {
      
      openDialog(sharing) {
        this.item = sharing;
        this.sharingDialog = true;
        clearTimeout(this.gettingFacebook);
        this.gettingFacebook = setTimeout(() => this.loadFacebookSDK(), 500);
        this.getUrlDown();
        // FB.XFBML.parse();
      },
      closeDialog(){
        this.sharingDialog = false;
      },
      getUrlDown() {
        this.currentURL = "https://wenewz.com" + "/api/share/" + this.item.articleId;
      },
      copyThisUrl() {
        this.$refs.gettingTheUrl.select();
        document.execCommand("copy");
      },
      loadFacebookSDK(){
        FB.XFBML.parse();
        // alert('aaaa')
      }
    },
  }
</script>
